<template>
	<main-page :color="pageColor" :hide-footer="true">
		<template v-slot:title>
			<template>SIGN UP</template>
		</template>
		<div class="container">
			<template v-if="loading"> </template>

			<template v-if="!loading">
				<div v-if="district" class="card p-4">
					<h1 class="si-font mt-0 pb-0">Welcome</h1>
					<div class="text-lg">You have been invited to join STEM Innovator®</div>
					<div class="d-flex flex-row justify-content-center w-100 mt-3">
						<div>
							<div class="si-font si-text-green" style="font-size: 2.25rem; line-height: 1;">
								{{ district.name }}
							</div>
							<div class="text-md rdfrtext-muted">Organization</div>
						</div>
						<div v-if="section" class="ml-5">
							<div class="si-font si-text-orange" style="font-size: 2.25rem; line-height: 1;">
								{{ section.name }}
							</div>
							<div class="text-md rdfrtext-muted">Class</div>
						</div>
					</div>
					<hr class="my-4" />

					<div class="login-box d-flex flex-column justify-content-between mx-auto shadow mt-3 mb-3">
						<div class="si-font" style="font-size: 36px; margin-bottom: 16px; line-height: 1;">
							Connect with Google
						</div>
						<a href="/v1/auth?provider=g_student" class="my-1 google-button" @click="goToGoogle">
							<img style="width: 280px;" src="@/assets/images/google_sign_in.png" />
							<div class="google-button-overlay">
								<div v-if="goingToGoogle" class="loading-overlay">
									<loading type="medium" />
								</div>
							</div>
						</a>
					</div>
					<h1 class="text-extra-muted text-center si-font mb-0">or</h1>
					<form
						@submit.prevent="submit"
						name="form"
						class="login-box d-flex flex-column justify-content-between mx-auto shadow mt-3"
					>
						<div class="si-font" style="font-size: 36px; margin-bottom: 16px; line-height: 1;">
							Create an Account
						</div>
						<div class="form-group">
							<label class="text-lg si-font si-text-orange">Email</label>
							<input type="text" class="login-input" placeholder="Email" required v-model.trim="email" />
						</div>
						<div class="row">
							<div class="col-6 form-group">
								<label class="text-lg si-font si-text-orange">First Name</label>
								<input
									type="text"
									class="login-input"
									placeholder="First name..."
									required
									v-model.trim="firstName"
								/>
							</div>
							<div class="col-6 form-group">
								<label class="text-lg si-font si-text-orange">Last Name</label>
								<input
									type="text"
									class="login-input"
									placeholder="Last name..."
									required
									v-model.trim="lastName"
								/>
							</div>
						</div>
						<div class="form-group">
							<label class="text-lg si-font si-text-orange">Password</label>
							<input
								type="password"
								class="login-input"
								placeholder="Password"
								required
								v-model.trim="password1"
							/>
						</div>
						<div class="form-group">
							<label class="text-lg si-font si-text-orange">Confirm Password</label>
							<input
								type="password"
								class="login-input"
								placeholder="Password"
								required
								v-model.trim="password2"
							/>
						</div>
						<div class="ml-2 form-group" style="min-height: 28px;">
							<div v-for="(error, i) in passwordErrors" :key="i" class="text-md text-danger">
								<i class="fas fa-exclamation-triangle mr-1" />{{ error }}
							</div>
						</div>
						<div class="d-flex justify-content-between">
							<button class="btn btn-si-orange" style="width: 100%;" type="submit">
								Create Account
							</button>
						</div>
					</form>
				</div>

				<div v-if="!district" class="mt-5 card py-4 px-5 d-flex flex-column align-items-center">
					<i class="fas fa-exclamation-triangle text-danger" style="font-size: 72px;" />
					<h1 class="mt-4 si-font">Invalid Invite</h1>
					<div class="text-md">Your invite link is not valid.</div>
					<div class="text-md">It may have expired, or you may have accessed this page incorrectly</div>
					<div class="text-muted">
						If you were expecting an invite to STEM Innovator®, please contact the teacher or administrator
						who offered it to you.
					</div>
				</div>
			</template>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AuthService from "@/services/AuthService";
import BrandService from "@/services/BrandService"
import Notie from "@/services/NotieService";
import Store from "@/services/Store";
import fs from "@/services/FormatService";

export default {
	name: "Invite",

	props: [],

	components: { MainPage },

	data() {
		let role = this.$route.params.role.toUpperCase();
		let code = this.$route.params.code.toUpperCase();
		let email = this.$route.query.email;
		return {
			fs: fs,

			loading: true,
			role: role,
			code: code,

			district: null,
			section: null,

			firstName: null,
			lastName: null,
			email: email,
			password1: null,
			password2: null,
			passwordErrors: [],

			goingToGoogle: false,

			brand: BrandService.getBrand(),
		};
	},

	watch: {
		password1() {
			this.checkValidPassword();
		},

		password2() {
			this.checkValidPassword();
		},
	},

	computed: {
		pageColor() {
			switch (this.role) {
				case "STUDENT":
					return "green";
				case "TEACHER":
					return "blue";
				case "PARTNER":
					return "orange";
				case "JUDGE":
					return "purple";
				default:
					return "yellow";
			}
		},
	},

	created() {
		this.checkJoinCode();
	},

	methods: {
		checkJoinCode() {
			AuthService.checkJoinCode(this.code, this.role)
				.then((r) => {
					this.loading = false;
					this.district = r.data.district;
					this.section = r.data.section;
				})
				.catch((e) => {
					this.loading = false;
					console.log(e);
				});
		},

		checkValidPassword() {
			this.canSetPassword = false;
			if (!(this.password1 && this.password2)) {
				return;
			}

			// TODO: Other restrictions (length, special characters, etc.)

			if (this.password1 != this.password2) {
				this.passwordErrors = ["The passwords must match"];
				return;
			}

			this.passwordErrors = [];
			this.canSetPassword = true;
		},

		submit() {
			if (this.password1 != this.password2) {
				Notie.error("Cannot create account", "Passwords do not match");
				return;
			}
			if (!this.email) {
				Notie.error("Cannot create account", "Email is required");
				return;
			}
			if (!(this.firstName || this.lastName)) {
				Notie.error("Cannot create account", "Name is required");
			}

			let name = { first: this.firstName, last: this.lastName };
			AuthService.createAccount(this.email, this.password1, name, this.role, this.code)
				.then(() => {
					AuthService.login(this.email, this.password1)
						.then((resp) => {
							// Successful login, but with redirect message
							if (resp.data) {
								if (resp.data.message == "toDistrictPick") {
									this.$router.push("/district_select");
								} else {
									Notie.error("Unexpected login error");
									console.log("UNEXPECTED LOGIN MESSAGE", resp);
								}
								return;
							}

							// Successful normal login
							let user = resp.user;
							console.log("LOGIN USER", user);
							if (user.role == "ADMIN") {
								this.$router.push("/admin");
							} else if (user.role == "TEACHER") {
								this.$router.push("/classes");
							} else if (user.role == "JUDGE") {
								this.$router.push("/pitches");
							} else {
								this.$router.push("/portfolio");
							}
						})
						.catch((e) => {
							console.log("FAILED LOGIN USER");
							console.log(e);
							Notie.error("Unauthorized", "Please check your username and password");
						});
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Could not create account", e);
				});
		},

		goToGoogle() {
			this.goingToGoogle = true;

			Store.set(this, "inviteRole", this.role);
			Store.set(this, "inviteCode", this.code);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-box {
	max-width: 600px;
	border: 6px solid rgb(254, 80, 0);
	padding: 2rem 2rem;
	background-color: #f7f7f7;
}

.login-input {
	background-color: rgba(255, 255, 255, 0.25);
	border: 3px solid black;
	width: 100%;
	padding: 6px;
	font-size: 18px;
	font-weight: 800;
	text-align: center;
}
</style>
